export const USER_ITEMS_IDS_REQUEST = "USER_ITEMS_REQUEST";
export const USER_ITEMS_IDS_SUCCESS = "USER_ITEMS_SUCCESS";
export const USER_ITEMS_IDS_FAIL = "USER_ITEMS_FAIL";
export const USER_ITEMS_IMX = "USER_ITEMS_IMX"
